import React, { useEffect, useState } from 'react';
import { Button, Upload, message, Image, Tag, Alert, Spin, Divider } from 'antd';
import { UploadOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Icon, Select, Toast, useForm, Controller, showDeleteOrRestoreMessage, showAddUpdateConfirm, showCustomConfirmMessage, useUser } from '../../utils/commonImports';
import { customStyleMd } from '../../utils/common';
import CustomModal from "../../components/Modal";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import axios from 'axios';
import { apiUrl } from '../../auth/Api';
import { _api } from '../../auth/Api';
import { getPageRights } from '../../utils/accessPages';

const visibilityOptions = [
    { value: 'registered', label: 'Registered Users' },
    { value: 'guest', label: 'Guest Users' },
    { value: 'both', label: 'Both Users' },
];

const navigateOptions = [
    { label: 'Home', value: 'Home' },
    { label: 'Profile', value: 'Profile' },
    { label: 'Otp Verification', value: 'OtpVerification' },
    { label: 'Reset Password', value: 'ResetPassword' },
    { label: 'Chassis Binding', value: 'Chassisbinding' },
    { label: 'My Appointments', value: 'AppointmentList' },
    { label: 'Schedule Maintenance', value: 'ScheduleMaintenance' },
    { label: 'Contact Us', value: 'ContactUs' },
    { label: 'Upload Documents', value: 'UplaodDocuments' },
    { label: 'Complain', value: 'Complain' },
    { label: 'My Complain', value: 'MyComplain' },
    { label: 'Generate Link', value: 'GenerateLink' },
    { label: 'Delete Account', value: 'DeleteAccount' },
    { label: 'Book Test Drive', value: 'BookTestDrive' },
    { label: 'Inquiry', value: 'Inquiry' },
    { label: 'About Us', value: 'AboutUs' },
    { label: 'Privacy Policy', value: 'PrivacyPolicy' },
    { label: 'Service History Detail', value: 'ServiceHistoryDetail' },
    { label: 'Contact Selection', value: 'ContactSelection' },
    { label: 'Request A Quote', value: 'RequestAQuote' },
    { label: 'Part Listing', value: 'PartListing' },
    { label: 'Update Password', value: 'UpdatePassword' },
    { label: 'Promotion Detail', value: 'PromotionDetail' },
    { label: 'Part Details', value: 'PartDetails' },
    { label: 'Cost Calculator', value: 'CostCalculator' },
    { label: 'Quote Details', value: 'QuoteDetails' },
    { label: 'Edit Profile', value: 'EditProfile' },
    { label: 'Find Dealer Location', value: 'FindDealerLocation' },
    { label: 'Notification', value: 'Notification' },
    { label: 'Appointment List', value: 'AppointmentList' },
    { label: 'Faq', value: 'Faq' },
    { label: 'Service History', value: 'ServiceHistory' },
    { label: 'Social Sign Up', value: 'SocialSignUp' }
]

const defaultValues = {
    title: '',
    navigateOn: '',
    visibleFor: '',
    file: null
};

const MobileAppMenus = () => {
    const { register, handleSubmit, setValue, reset, control, formState: { errors } } = useForm({ defaultValues });
    const [menus, setMenus] = useState([]);
    const [editKey, setEditKey] = useState(null);
    const [iconPreview, setIconPreview] = useState(null);
    const [iconFile, setIconFile] = useState(null);
    const [loading, setLoading] = useState(false);
    //const [isLoading, setIsLoading] = useState(false);
    const [isRearrangeModalVisible, setIsRearrangeModalVisible] = useState(false);
    const [tempMenus, setTempMenus] = useState([]);

    const { loggedInUser } = useUser();
    const userPages = loggedInUser?.roles?.[0]?.pages || [];
    const rights = getPageRights(userPages, 9);

    useEffect(() => {
        _getMenus();
    }, []);

    const _getMenus = async () => {
        try {
            await _api('GET', 'MenuItems/GetAllActiveMenuItems', null, (r) => {
                if (r.isSuccess) {
                    setMenus(r.data);
                }
            });
        } catch (error) {
            console.log(error)
        }
    };

    const handleEdit = (menu) => {
        setValue("title", menu.title);
        setValue("navigateOn", navigateOptions.find(opt => opt.value === menu.navigateOn) || null);
        setValue("visibleFor", visibilityOptions.find(opt => opt.value === menu.visibleFor) || null);
        setValue("ImageUrl", menu.imageUrl);
        setIconPreview(menu.imageUrl);
        setIconFile(null);
        setEditKey(menu.menuId);
    };

    const handleSaveMenu = async (data) => {
        const isSure = await showAddUpdateConfirm(`Are you sure! you want to ${editKey ? "update" : "add "} this Icon?`)
        if (isSure) {
            setLoading(true);
            try {
                const formData = new FormData();
                formData.append("Title", data.title);
                formData.append("NavigateOn", data.navigateOn?.value || '');
                formData.append("VisibleFor", data.visibleFor?.value || '');
                if (iconFile) {
                    formData.append("File", iconFile);
                } else if (data.ImageUrl) {
                    formData.append("ImageUrl", data.ImageUrl);
                }

                if (editKey) {
                    formData.append("MenuId", editKey);
                }

                const storedToken = localStorage.getItem("x_t");
                const token = storedToken ? JSON.parse(storedToken).t : null;
                const endpoint = editKey ? `${apiUrl}MenuItems/Update` : `${apiUrl}MenuItems/Add`
                const res = await axios.post(endpoint, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                });

                if (res?.data?.isSuccess) {
                    Toast.fire({ icon: 'success', title: res?.data?.message })
                    _getMenus();
                    resetForm();
                } else {
                    Toast.fire({ icon: 'error', title: res?.data?.message })
                }
            } catch (error) {
                Toast.fire({ icon: 'error', title: editKey ? 'Failed to update menu' : 'Failed to add menu' })
                console.error('Error saving menu:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    const _deleteMenu = async (d) => {
        const isConfirmed = await showDeleteOrRestoreMessage(d?.isActive ? "Delete" : "Restore");
        if (isConfirmed) {
            try {
                //const payload = {}
                await _api('POST', 'MenuItems/Delete', { menuId: d?.menuId }, function (res) {
                    if (res.isSuccess) {
                        _getMenus();
                        Toast.fire({ icon: 'success', title: res.message })
                    } else {
                        Toast.fire({ icon: 'error', title: res.message })
                    }
                });
            } catch (error) {
                console.log(error);
            }
        }
    };

    const resetForm = () => {
        reset(defaultValues);
        setIconPreview(null);
        setIconFile(null);
        setEditKey(null);
    };

    const getBadgeColor = (type) => {
        switch (type) {
            case 'guest': return 'processing';
            case 'registered': return 'success';
            case 'both': return 'default';
            default: return 'default';
        }
    };

    const uploadProps = {
        beforeUpload: (file) => {
            const isImage = file.type.startsWith('image/');
            if (!isImage) {
                message.error('Only images allowed');
                return false;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                setIconPreview(e.target.result);
                setIconFile(file);
                setValue('File', null); // Clear URL if uploading new file
            };
            reader.readAsDataURL(file);
            return false;
        },
        showUploadList: false,
        accept: 'image/*',
    };

    const showRearrangeModal = () => {
        setTempMenus([...menus]);
        setIsRearrangeModalVisible(true);
    };

    const handleSave = async () => {
        const isYes = await showCustomConfirmMessage({ message: "Are you sure! you want to rearrange the menus?", icon: 'info' })
        if (isYes) {
            // setIsLoading(true)
            try {
                const menuOrder = tempMenus?.map((menu, index) => ({ menuId: menu.menuId, index: index }));
                await _api("POST", "MenuItems/RearrangeMenuItems", menuOrder, (res) => {
                    if (res.isSuccess) {
                        _getMenus();
                        setIsRearrangeModalVisible(false);
                        Toast.fire({ icon: "success", title: res?.message })
                    } else {
                        Toast.fire({ icon: "error", title: res?.message })
                    }
                })
            } catch (err) {
                Toast.fire({ icon: "error", title: err?.message })
            } finally {
                // setIsLoading(false)
            }
        }
    };

    const onDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(tempMenus);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        setTempMenus(items);
    };

    return (
        <div className="">
            <Alert type="info" closable showIcon className="mb-3"
                description={
                    <>
                        Configure your mobile app menus here. Assign icons, navigation paths, and set visibility for different user types (Guest, Registered, or Both).                    </>
                }
            />

            <Spin spinning={loading}>
                <form onSubmit={handleSubmit(handleSaveMenu)}>
                    <div className="row">
                        {/* Title */}
                        <div className="col-md-3">
                            <div className="form-group input-group-md">
                                <label className="small">Title</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter title"
                                    {...register("title", { required: "Title is required" })}
                                />
                                {errors.title && <small className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">{errors.title.message}</small>}
                            </div>
                        </div>

                        {/* Navigate */}
                        <div className="col-md-3">
                            <div className="form-group input-group-md">
                                <label className="small">Navigate On</label>
                                <Controller
                                    name="navigateOn"
                                    control={control}
                                    rules={{ required: "Navigation is required" }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            options={navigateOptions}
                                            placeholder="Select Navigation"
                                            styles={customStyleMd}
                                        // className={errors.navigateOn ? 'react-select-invalid' : ''}
                                        />
                                    )}
                                />
                                {errors.navigateOn && <small className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">{errors.navigateOn.message}</small>}
                            </div>
                        </div>

                        {/* Visible For */}
                        <div className="col-md-3">
                            <div className="form-group input-group-md">
                                <label className="small">Visible For</label>
                                <Controller
                                    name="visibleFor"
                                    control={control}
                                    rules={{ required: "Visibility is required" }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            options={visibilityOptions}
                                            placeholder="Select Visibility"
                                            styles={customStyleMd}
                                        //className={errors.visibleFor ? 'react-select-invalid' : ''}
                                        />
                                    )}
                                />
                                {errors.visibleFor && <small className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">{errors.visibleFor.message}</small>}
                            </div>
                        </div>

                        {/* Upload Icon */}
                        <div className="col-md-3">
                            <div className="form-group input-group-md">
                                <label className="small">Upload Icon</label>
                                <div>
                                    {!iconPreview ? (
                                        <Upload {...uploadProps}>
                                            <button type="button"
                                                style={{
                                                    height: '43px', border: '1px solid #d1d5db', width: '100%', textAlign: 'left', transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                                                    fontSize: "14px", fontWeight: 400, backgroundColor: '#fff', color: '#495057', borderRadius: '0.375rem', padding: "0px 12px",
                                                }} >
                                                <UploadOutlined style={{ marginRight: 6 }} /> Upload
                                            </button>
                                        </Upload>
                                    ) : (
                                        <div
                                            style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '15px', border: '1px solid #dee2e6', borderRadius: '6px', backgroundColor: '#f8f9fa', width: '100%', flexWrap: 'wrap' }} >
                                            <Image src={iconPreview} width={60} height={60} preview={false} style={{ objectFit: 'contain', borderRadius: 4 }} />
                                            <div style={{ display: 'flex', gap: '6px' }}>
                                                <Upload {...uploadProps}>
                                                    <button type='button' className="btn btn-outline-secondary px-3  py-1 text-sm">Change</button>
                                                </Upload>
                                                <button type='button' onClick={() => { setIconPreview(null); setIconFile(null); }} className="btn btn-outline-secondary px-3  py-1 text-sm"> Remove </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Submit / Cancel */}
                        <Divider orientation="right" plain orientationMargin={0}>
                            <div className="row">
                                <div className="d-flex justify-content-end gap-2">
                                    {rights && rights.edit && !editKey && (
                                        <button type="button" style={{ lineHeight: '1.2' }} onClick={showRearrangeModal}
                                            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm"
                                        >
                                            Rearrange Menus
                                            <Icon icon="mdi:format-list-numbered" className="text-md" />
                                        </button>
                                    )}
                                    {rights && rights.add && (
                                        <button type="submit" style={{ lineHeight: '1.2' }} disabled={loading}
                                            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm"
                                        >
                                            {editKey ? 'Update Menu' : 'Add Menu'}
                                            <Icon icon="mdi:plus-circle-outline" className="text-md" />
                                        </button>
                                    )}
                                    {editKey && (
                                        <button type="button" onClick={resetForm} className="btn btn-secondary px-3 py-2 text-sm" disabled={loading} >
                                            Cancel
                                        </button>
                                    )}
                                </div>
                            </div>
                        </Divider>
                    </div>
                </form>

                <div className="row g-3">
                    {menus.length > 0 &&
                        menus.map(menu => (
                            <div className="col-md-4 col-lg-3" key={menu.menuId}>
                                <div className="d-flex h-100 p-3 bg-white rounded border">
                                    {/* Icon Box */}
                                    <div className="me-3 d-flex align-items-center justify-content-center bg-light rounded" style={{ width: 80, height: 80, flexShrink: 0 }}>
                                        <Image src={menu.imageUrl || menu.iconPreview} width={50} height={50} preview={false} style={{ objectFit: 'contain', borderRadius: 4 }} />
                                    </div>

                                    {/* Content Section */}
                                    <div className="d-flex flex-column justify-content-between w-100">
                                        <div>
                                            <div className="fw-semibold text-dark mb-1 text-xs" title={menu.title} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '90%' }}>
                                                {menu.title}
                                            </div>
                                            <div className="d-flex align-items-center mb-1">
                                                <span className="me-1 text-muted text-xs">For:</span>
                                                <Tag color={getBadgeColor(menu.visibleFor)} style={{ fontSize: 11, fontWeight: 500, borderRadius: 4 }}>
                                                    {menu.visibleFor === 'both' ? 'Both Users' : menu.visibleFor === 'guest' ? 'Guest Users' : 'Registered Users'}
                                                </Tag>
                                            </div>
                                        </div>

                                        {/* Buttons */}
                                        <div className="d-flex gap-2">
                                            {rights && rights.edit && (
                                                <Button size="small" onClick={() => handleEdit(menu)} style={{ border: '1px solid #d9d9d9', color: '#333', backgroundColor: '#fff', borderRadius: 4, height: 26, fontSize: 12, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6 }}>
                                                    <EditOutlined style={{ fontSize: 12 }} /> Edit
                                                </Button>
                                            )}
                                            {rights && rights.delete && (
                                                <Button size="small" onClick={() => _deleteMenu(menu)} title='Not Allowed' style={{ border: '1px solid #d9d9d9', color: '#d93025', backgroundColor: '#fff', borderRadius: 4, height: 26, fontSize: 12, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6 }}>
                                                    <DeleteOutlined style={{ fontSize: 12 }} /> Delete
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            </Spin>

            <CustomModal
                title="Rearrange Menus"
                size="md"
                show={isRearrangeModalVisible}
                onHide={() => setIsRearrangeModalVisible(false)}
                showBtn={true}
                isSaveBtn
                onSave={handleSave}
            >
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="menuItems">
                        {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                                {tempMenus.map((menu, index) => (
                                    <Draggable key={menu.menuId} draggableId={String(menu.menuId)} index={index}>
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={{
                                                    ...provided.draggableProps.style,
                                                    marginBottom: 5,
                                                    padding: 10,
                                                    backgroundColor: '#F8F9FA',
                                                    border: "1px solid #10477fe3",
                                                    borderRadius: 4,
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <div style={{ marginRight: 10, width: 50, height: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <Image
                                                        src={menu.imageUrl || menu.iconPreview}
                                                        width={35}
                                                        height={35}
                                                        preview={false}
                                                        style={{ objectFit: 'contain', borderRadius: 4 }}
                                                    />
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                    <div className="fw-normal text-sm">{menu.title}</div>
                                                    <Tag color={getBadgeColor(menu.visibleFor)} style={{ fontSize: 11, fontWeight: 500, borderRadius: 4 }}>
                                                        {menu.visibleFor === 'both' ? 'Both Users' : menu.visibleFor === 'guest' ? 'Guest Users' : 'Registered Users'}
                                                    </Tag>
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </CustomModal>
        </div>
    );
};

export default MobileAppMenus;